t = require('app/scripts/views/internal/teacup-with-helpers')('header_version_picker')

module.exports = ->
  t.div '.form-grid', ->

    t.div '.button-link.setting.form-grid-child.form-grid-child-full', ->
      t.span '.label', ->
        t.format 'head'
      t.span '.value', ->
        t.text t.mustacheVar('active.name')
      t.label ->
        t.format 'head'
      t.select '.js-select-head', ->
        t.mustacheBlock 'heads', ->
          t.optionSelected t.mustacheVar('selected'), { value: t.mustacheVar('value') }, ->
            t.text t.mustacheVar('displayName')
            t.mustacheBlock 'selected', ->
              t.format 'current'

    t.mustacheBlock 'versions.2.value', ->
      t.div '.button-link.setting.form-grid-child.form-grid-child-full', ->
        t.span '.label', ->
          t.format 'version'
        t.span '.value', ->
          t.text t.mustacheVar('active.version')
        t.label ->
          t.format 'version'
        t.select '.js-select-version', ->
          t.mustacheBlock 'versions', ->
            t.optionSelected t.mustacheVar('selected'), { value: t.mustacheVar('value') }, ->
              t.text t.mustacheVar('displayName')
              t.mustacheBlockInverted 'active', ->
                t.text ' '
                t.format 'disabled'
              t.mustacheBlock 'selected', ->
                t.text ' '
                t.format 'current'

